import { TUserRole } from "@/modules/authentication/authentication.type";
import { Roles } from "@/modules/authentication/components/Permission/permission.type";
import { Workbook } from "./workbook";

export interface FormRequest {
  wbid: string;
  userid: string;
  ownerid: string;
  reqcanview: boolean;
  reqcanedit: boolean;
  reqmessage: string;
  username: string;
  ownername: string;
}

export interface FormApprove {
  rid: string;
  appcanview: boolean;
  appcanedit: boolean;
  appmessage: string;
}

export interface FormReject {
  rid: string;
  appmessage: string;
}

export enum RequestStatus {
  RPending = "pending",
  Approved = "approved",
  RRejected = "rejected",
  ARPending = "pending authorization",
  ARRejected = "authorization rejected",
  Retracted = "retracted",
}
export interface RequestItem {
  rid: number;
  wbid: string;
  userid: string;
  username: string;
  ownerid: string;
  ownername: string;
  reqcanview: boolean;
  reqcanedit: boolean;
  reqmessage: string;
  status: RequestStatus | string;
  appcanview: string | null;
  appcanedit: string | null;
  appmessage: string | null;
  created: string;
  actionat: string | null;
  authorizedby: string | null;
  authorizermsg: string | null;
  authorizername: string | null;
  type: "requested" | string;
  discoverable?: boolean;
  userbranchname: string;
  userdivisionname: string;
  ownerbranchname: string;
  ownerdivisionname: string;
  dashboardname: string;
  description?: string;
  authorizerbranchname?: string;
  authorizerdivisionname?: string;
  requestorrole?: Roles; //ROLE OF REQUESTOR
  userrole?: TUserRole;
}

export interface AuthorizationItem {
  rid: string;
  wbid: string;
  userid: string;
  username: string;
  ownerid: string;
  ownername: string;
  reqcanview: boolean;
  reqcanedit: boolean;
  reqmessage: string;
  status: string | RequestStatus;
  appcanview: boolean | null;
  appcanedit: boolean | null;
  appmessage: string | null;
  created: string | null;
  actionat: string | null;
  authorizedby: string;
  authorizermsg: string;
  authorizername: string;
  authorizerbranchname?: string;
  authorizerdivisionname?: string;
  discoverable?: boolean;
  type: "requested" | string | null;
  branchid: number;
  userbranchname: string;
  userdivisionname: string;
  ownerbranchname: string;
  ownerdivisionname: string;
  dashboardname: string;
  description: string;
  requestorrole?: Roles;
  userrole?: TUserRole;
  workbook?: Workbook;
}

export interface AuthorizeForm {
  rid: string;
  authorizermsg: string;
}

export interface BulkMyApprovalRequest {
  rid: number[];
  appmessage: string;
}

export interface BulkAuthorizeRequest {
  rid: string[];
  authorizermsg: string;
}
